<div class="nav-container">
  <div class="col-md-12 color-span nav-detail">
    <div class="col-md-12 title-row f-left mt-1">
      <span class="title">
        {{ "tenants-property.marketsStatsConfiguration" | translate }}
      </span>
    </div>
  </div>
</div>
<div class="content">
  <app-loading-spinner *ngIf="!showDetail"></app-loading-spinner>
  <div *ngIf="showDetail" class="content-detail">
    <div class="col-md-12 mt-4">
      <div class="col-md-12">
        <div class="action-row" *ngIf="isResearchAdmin">
          <button
            class="btn btn-primary market-rent-btn"
            (click)="openMarketRentModal()"
          >
            {{ "tenants-property.newToStats" | translate }}
          </button>
          <button
            class="btn btn-primary market-rent-btn"
            (click)="openFlagsReportModal()"
          >
            {{ "tenants-property.flagsReport" | translate }}
          </button>
        </div>
        <div
          class="col-md-12 key-facts"
          style="position: relative; display: flex; align-items: center; padding-top: 0px;"
        >
          <span
            style="position: absolute; left: 50%; transform: translateX(-50%); font-weight: 600;"
            >{{ getNextYearFromFirstTenant() }}
            {{ getNextQuarterFromFirstTenant() }}
            {{ "tenants-property.progress" | translate }}</span
          >
          <!--  <span
            style="margin-left: auto; color: cornflowerblue; 
          text-decoration-line: underline; 
          cursor: pointer;"
            (click)="openStatsDashboard()"
          >
            {{ "tenants-property.linkToStatsBookingDashboard" | translate }}
          </span> -->
        </div>
        <div class="table-unitmix">
          <table class="table">
            <thead class="head-vacant title-row unitmixheaders">
              <tr>
                <th style="text-align: left; width: 200px;">
                  {{ "tenants-property.market" | translate }}
                </th>
                <th class="progress-th" style="text-align: left; width: 200px;">
                  {{ "tenants-property.progress" | translate }}
                </th>
                <th style="text-align: left; width: 180px;">
                  {{ "tenants-property.researcher" | translate }}
                </th>
                <th style="text-align: left; width: 180px;">
                  {{ "tenants-property.researchLead" | translate }}
                </th>
                <th style="text-align: left; width: 180px;">
                  {{ "tenants-property.countryManager" | translate }}
                </th>
              </tr>
            </thead>
            <tbody
              class="border-table title-row unitmixtablerows"
              style="text-align: left; font-size: small;"
            >
              <tr *ngFor="let data of marketConfigs; let i = index">
                <td>
                  <span
                    (click)="openStatsPageByMarket(data.marketId)"
                    style="cursor: pointer; text-decoration: underline; color: #007bff;"
                    >{{ data.marketName | langSelector }}</span
                  >
                </td>
                <td>
                  <div style="display: flex;">
                    <div class="progress progress-td" style="width: 85%;">
                      <!-- <div
                        class="progress-bar"
                        role="progressbar"
                        [style.width]="(data.totalSubmitted / data.totalBuildings * 100) + '%'"
                        [attr.aria-valuenow]="data.totalSubmitted"
                        [attr.aria-valuemin]="0"
                        [attr.aria-valuemax]="data.totalBuildings"
                      ></div>
                      <div
                        class="progress-bar bg-success"
                        role="progressbar"
                        [style.width]="(data.totalApproved / data.totalBuildings * 100) + '%'"
                        [attr.aria-valuenow]="data.totalApproved"
                        [attr.aria-valuemin]="0"
                        [attr.aria-valuemax]="data.totalBuildings"
                      ></div>
                      <div
                        class="progress-bar bg-info"
                        role="progressbar"
                        [style.width]="(data.totalRejected / data.totalBuildings * 100) + '%'"
                        [attr.aria-valuenow]="data.totalRejected"
                        [attr.aria-valuemin]="0"
                        [attr.aria-valuemax]="data.totalBuildings"
                      ></div> -->
                      <div
                        class="progress-bar progress-yellow-2"
                        role="progressbar"
                        [style.width]="
                          (data.totalTentative / data.totalBuildings) * 100 +
                          '%'
                        "
                        [attr.aria-valuenow]="data.totalTentative"
                        [attr.aria-valuemin]="0"
                        [attr.aria-valuemax]="data.totalBuildings"
                        [matTooltip]="
                          data.totalTentative > 0
                            ? data.totalTentative + ' assets tentative'
                            : null
                        "
                        matTooltipPosition="above"
                        *ngIf="data.status != 'APPROVED BY MGMT'"
                      ></div>
                      <div
                        class="progress-bar progress-yellow"
                        role="progressbar"
                        [style.width]="
                          (data.totalSubmitted / data.totalBuildings) * 100 +
                          '%'
                        "
                        [attr.aria-valuenow]="data.totalSubmitted"
                        [attr.aria-valuemin]="0"
                        [attr.aria-valuemax]="data.totalBuildings"
                        [matTooltip]="
                          data.totalSubmitted > 0
                            ? data.totalSubmitted + ' assets submitted'
                            : null
                        "
                        matTooltipPosition="above"
                        *ngIf="data.status != 'APPROVED BY MGMT'"
                      ></div>
                      <div
                        class="progress-bar progress-light-green"
                        role="progressbar"
                        [style.width]="
                          (data.totalApproved / data.totalBuildings) * 100 + '%'
                        "
                        [attr.aria-valuenow]="data.totalApproved"
                        [attr.aria-valuemin]="0"
                        [attr.aria-valuemax]="data.totalBuildings"
                        [matTooltip]="
                          data.totalApproved > 0
                            ? data.totalApproved + ' assets approved'
                            : null
                        "
                        matTooltipPosition="above"
                        *ngIf="data.status != 'APPROVED BY MGMT'"
                      ></div>
                      <div
                        class="progress-bar progress-red"
                        role="progressbar"
                        [style.width]="
                          (data.totalRejected / data.totalBuildings) * 100 + '%'
                        "
                        [attr.aria-valuenow]="data.totalRejected"
                        [attr.aria-valuemin]="0"
                        [attr.aria-valuemax]="data.totalBuildings"
                        [matTooltip]="
                          data.totalRejected > 0
                            ? data.totalRejected + ' assets rejected'
                            : null
                        "
                        matTooltipPosition="above"
                        *ngIf="data.status != 'APPROVED BY MGMT'"
                      ></div>
                      <div
                        class="progress-bar progress-dark-green"
                        role="progressbar"
                        [style.width]="1 * 100 + '%'"
                        [attr.aria-valuenow]="data.totalBuildings"
                        [attr.aria-valuemin]="0"
                        [attr.aria-valuemax]="data.totalBuildings"
                        [matTooltip]="Completed"
                        matTooltipPosition="above"
                        *ngIf="data.status == 'APPROVED BY MGMT'"
                      ></div>
                    </div>
                    <div
                      style="width: 15%; padding-left: 5px; font-weight: 600;"
                    >
                      {{ getProgressBarLegend(data) }}
                      <span style="color: red;">
                        {{ getRejectedLegend(data) }}</span
                      >
                    </div>
                  </div>
                </td>
                <td>
                  <span *ngIf="!isResearchAdmin">{{
                    data.researcherName
                  }}</span>
                  <select
                    [(ngModel)]="data.researcherName"
                    (ngModelChange)="
                      onResearcherSelected($event, data.marketId)
                    "
                    style="width: 100%;"
                    *ngIf="isResearchAdmin"
                  >
                    <option
                      *ngFor="let user of researchUsers"
                      [ngValue]="user.name"
                    >
                      {{ user.name }}
                    </option>
                  </select>
                </td>
                <td>
                  <span *ngIf="!isResearchAdmin">{{
                    data.leadResearcherName
                  }}</span>
                  <select
                    [(ngModel)]="data.leadResearcherName"
                    (ngModelChange)="onLeadSelected($event, data.marketId)"
                    style="width: 100%;"
                    *ngIf="isResearchAdmin"
                  >
                    <option
                      *ngFor="let user of leadResearchUsers"
                      [ngValue]="user.name"
                    >
                      {{ user.name }}
                    </option>
                  </select>
                </td>
                <td>
                  {{ data.countryManagerName }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <wait-spinner *ngIf="showSpinner"></wait-spinner>
</div>

<!-- NgbModal Template -->
<ng-template #chartModal let-modal>
  <div class="custom-modal custom-modal-centered modal-80vh">
    <div class="modal-header">
      <h5 class="modal-title">
        {{ getModalTitle() }}
      </h5>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="closeModal()"
      ></button>
    </div>
    <div class="modal-body">
      <div class="table-tenant-popup" style="height: 300px;">
        <div class="d-flex" *ngIf="currentAction == 'moveIn'">
          <div class="form-check form-switch" style="padding-left: 2.5em;">
            <input
              class="form-check-input"
              type="checkbox"
              id="flexSwitchCheckDefault"
              [(ngModel)]="splitSuite"
            />
            <label class="form-check-label" for="flexSwitchCheckDefault">{{
              "tenants-property.splitSuite" | translate
            }}</label>
          </div>
        </div>
        <table class="table">
          <thead
            class="head-vacant"
            style="text-align: center; background-color: #5a86a3;"
          >
            <tr>
              <th style="width: 80px;">
                {{ "tenants-property.floorModule" | translate }}
              </th>
              <th style="max-width: 100px;">
                {{ "tenants-property.suiteWarehouse" | translate }}
              </th>
              <th style="max-width: 100px;">
                {{ "tenants-property.area" | translate }} (m²)
              </th>
              <th style="min-width: 200px;">
                {{ "tenants-property.tenant" | translate }}
              </th>
              <th
                *ngIf="currentAction == 'edit' || currentAction == 'moveIn'"
                style="max-width: 120px;"
              >
                {{ "tenants-property.industry" | translate }}
              </th>
              <th
                *ngIf="currentAction == 'moveOut' || currentAction == 'moveIn'"
                style="max-width: 120px;"
              >
                {{ "tenants-property.date" | translate }}
              </th>
              <th *ngIf="currentAction == 'moveOut'" style="max-width: 120px;">
                {{ "tenants-property.askingRentMXN" | translate }}
              </th>
              <th *ngIf="currentAction == 'moveOut'" style="max-width: 120px;">
                {{ "tenants-property.askingRentUSD" | translate }}
              </th>
            </tr>
          </thead>
          <tbody style="text-align: center;">
            <tr style="height: 50px;">
              <td>
                {{ selectedTenant.floorModule }}
              </td>
              <td>
                {{ selectedTenant.suiteWarehouse }}
              </td>
              <td *ngIf="!splitSuite">
                {{ selectedTenant.area | localNumber: "1.2-2" }}
              </td>
              <td *ngIf="splitSuite">
                <input
                  type="number"
                  [(ngModel)]="newTenantArea"
                  style="width: 120px;"
                  min="0"
                  max="{{ selectedTenant.area }}"
                />
              </td>
              <td>
                <div
                  style="position: relative; text-align: start;"
                  *ngIf="currentAction != 'edit' && currentAction != 'moveIn'"
                >
                  <span> {{ editTenantName }} </span>
                </div>
                <div
                  style="position: relative; text-align: start; width: 100%;"
                  *ngIf="currentAction == 'edit' || currentAction == 'moveIn'"
                >
                  <span *ngIf="addTenantMode"> {{ editTenantName }} </span>
                  <input
                    *ngIf="!addTenantMode"
                    type="text"
                    [(ngModel)]="editTenantName"
                    (input)="onInputChange($event)"
                    placeholder="Type to search..."
                    [ngClass]="{ loading: isLoading }"
                    style="width: 100%;"
                  />
                  <!-- Loading icon, only shown when isLoading is true -->
                  <span *ngIf="isLoading" class="loading-icon">🔄</span>

                  <!-- Autocomplete dropdown -->
                  <ul
                    *ngIf="autocompleteResults.length && !isLoading"
                    class="autocomplete-dropdown"
                    style="z-index: 1;"
                  >
                    <li
                      *ngFor="let option of autocompleteResults"
                      (click)="onSelectOption(option)"
                    >
                      {{ option.tenantName }}
                    </li>
                  </ul>
                </div>
                <div
                  style="text-align: left; font-size: smaller;"
                  *ngIf="showAddTenants && !addTenantMode"
                >
                  <label
                    (click)="onAddTenant()"
                    style="cursor: pointer; color: #007bff; text-decoration: underline; margin: 0; padding: 0;"
                  >
                    {{ "tenants-property.addAsNewTenant" | translate }}
                  </label>
                </div>
                <div
                  style="text-align: left; font-size: smaller;"
                  *ngIf="addTenantMode"
                >
                  <label
                    (click)="onBackToSearchTenant()"
                    style="cursor: pointer; color: #007bff; text-decoration: underline; margin: 0; padding: 0;"
                  >
                    {{ "tenants-property.backToSearch" | translate }}
                  </label>
                </div>
              </td>
              <td *ngIf="currentAction == 'edit' || currentAction == 'moveIn'">
                <span *ngIf="editIndustryName && !addTenantMode">
                  {{ editIndustryName | langSelector }}</span
                >
                <select
                  [(ngModel)]="selectedMarketSegment"
                  style="width: 100%;"
                  *ngIf="addTenantMode"
                >
                  <option
                    *ngFor="let segment of marketSegments"
                    [ngValue]="segment"
                  >
                    {{ segment.name | langSelector }}
                  </option>
                </select>
              </td>
              <td
                *ngIf="currentAction == 'moveOut' || currentAction == 'moveIn'"
              >
                <input
                  type="date"
                  [(ngModel)]="editMoveOutDate"
                  style="width: 120px;"
                />
              </td>
              <td *ngIf="currentAction == 'moveOut'">
                <input
                  type="number"
                  [(ngModel)]="editAskingRentMXN"
                  style="width: 120px;"
                />
              </td>
              <td *ngIf="currentAction == 'moveOut'">
                <input
                  type="number"
                  [(ngModel)]="editAskingRentUSD"
                  style="width: 120px;"
                />
              </td>
            </tr>
            <tr *ngIf="splitSuite" style="height: 50px;">
              <td>
                {{ selectedTenant.floorModule }}
              </td>
              <td>{{ selectedTenant.suiteWarehouse }}-A</td>
              <td>
                {{ selectedTenant.area - newTenantArea | localNumber: "1.2-2" }}
              </td>
              <td>
                <div style="position: relative; text-align: start;">
                  <span> Vacant </span>
                </div>
              </td>
              <td>
                <span></span>
              </td>
              <td>
                <span></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="discardChanges()"
      >
        {{ "tenants-property.discardChanges" | translate }}
      </button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="!validateSaveButton()"
        (click)="saveChanges()"
      >
        {{ "tenants-property.save" | translate }}
      </button>
      <button type="button" class="btn btn-secondary" (click)="closeModal()">
        {{ "tenants-property.close" | translate }}
      </button>
    </div>
  </div>
</ng-template>
<ng-template #marketRentModal>
  <div
    class="modal-header custom-modal-class-tenants"
    style="padding: 0; border-bottom: 0; padding-bottom: 30px;"
  >
    <h4 class="modal-title" style="font-weight: 600;">
      {{ "tenants-property.newToStats" | translate }}
    </h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="cancelSubmission()"
    ></button>
  </div>
  <div mat-dialog-content>
    <!-- Country Tab Selector - Only visible for MX platform -->
    <div
      class="country-type-selector"
      style="margin-bottom: 20px;"
      *ngIf="isMX()"
    >
      <div class="btn-group" role="group">
        <button
          type="button"
          class="btn"
          [class.btn-primary]="selectedCountryId === 2001"
          [class.btn-secondary]="selectedCountryId !== 2001"
          (click)="onCountryTabChange(2001)"
        >
          {{ "tenants-property.country_MX" | translate }}
        </button>
        <button
          type="button"
          class="btn"
          [class.btn-primary]="selectedCountryId === 3001"
          [class.btn-secondary]="selectedCountryId !== 3001"
          (click)="onCountryTabChange(3001)"
        >
          {{ "tenants-property.countryCO" | translate }}
        </button>
      </div>
    </div>
    <!-- Tab Selector -->
    <div class="area-type-selector" style="margin-bottom: 20px;">
      <div class="btn-group" role="group">
        <button
          type="button"
          class="btn"
          [class.btn-primary]="selectedMarketRentTab === 'add'"
          [class.btn-secondary]="selectedMarketRentTab !== 'add'"
          (click)="onMarketRentTabChange('add')"
        >
          {{ "tenants-property.addToStats" | translate }}
        </button>
        <button
          type="button"
          class="btn"
          [class.btn-primary]="selectedMarketRentTab === 'new'"
          [class.btn-secondary]="selectedMarketRentTab !== 'new'"
          (click)="onMarketRentTabChange('new')"
        >
          {{ "tenants-property.newThisQuarter" | translate }}
        </button>
      </div>
    </div>
    <div class="modal-table-container">
      <!-- Loading Spinner -->
      <div
        *ngIf="isLoadingMarketRentData"
        class="text-center"
        style="padding: 40px;"
      >
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2" style="color: #666;">Loading data...</p>
      </div>

      <!-- Floor Area Tab -->
      <div *ngIf="selectedMarketRentTab === 'add' && !isLoadingMarketRentData">
        <table
          class="table mobile-table"
          *ngIf="
            propertiesAvailableToAdd && propertiesAvailableToAdd.length > 0
          "
        >
          <thead>
            <tr>
              <th>{{ "tenants-property.market" | translate }}</th>
              <th>{{ "tenants-property.siilaId" | translate }}</th>
              <th>{{ "tenants-property.propertyName" | translate }}</th>
              <th>{{ "tenants-property.constructionStatus" | translate }}</th>
              <th>{{ "tenants-property.deliveryDate" | translate }}</th>
              <th>{{ "tenants-property.tenants" | translate }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of propertiesAvailableToAdd">
              <td>{{ row.market | langSelector }}</td>
              <td>{{ row.buildingId }}</td>
              <td>
                <a
                  style="color: #3399cc; text-decoration: underline; font-weight: 600; cursor: pointer;"
                  (click)="openPropertyPage(row.buildingId)"
                  >{{ row.buildingName }}</a
                >
              </td>
              <td>{{ row.status | langSelector }}</td>
              <td>{{ row.deliveredDate | date: "dd/MM/yyyy" }}</td>
              <td>
                <ng-container
                  *ngIf="row.tenants || row.tenantsLatestQuarter; else noTable"
                >
                  <a
                    style="color: #3399cc; text-decoration: underline; font-weight: 600; cursor: pointer;"
                    (click)="openTenantsPage(row.buildingId)"
                    *ngIf="row.tenantsLatestQuarter"
                    >{{ "tenants-property.view" | translate }}</a
                  >
                  <a
                    style="color: #d32f2f; text-decoration: underline; font-weight: 600; cursor: pointer;"
                    (click)="openTenantsPage(row.buildingId)"
                    *ngIf="!row.tenantsLatestQuarter"
                    >{{ "tenants-property.update" | translate }}</a
                  >
                </ng-container>
                <ng-template #noTable>
                  <span
                    (click)="openTenantsPage(row.buildingId)"
                    style="color: #d32f2f; font-weight: 700; cursor: pointer; text-decoration: underline;"
                    >{{ "tenants-property.noTable" | translate }}</span
                  >
                </ng-template>
              </td>
              <td style="text-align: center;">
                <button
                  (click)="onMarketRentAdd(row)"
                  [disabled]="!(row.tenants || row.tenantsLatestQuarter)"
                  style="background: #ffe066; color: #222; border: 1px solid #bfa600; font-weight: 700; padding: 2px 18px; border-radius: 3px; text-transform: uppercase;"
                >
                  {{ "tenants-property.add" | translate }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          *ngIf="
            propertiesAvailableToAdd && propertiesAvailableToAdd.length === 0
          "
          style="text-align: center; padding: 20px; color: #888; font-weight: 600;"
        >
          {{ "tenants-property.noPropertiesToShow" | translate }}
        </div>
      </div>
      <!-- Suite Area Tab -->
      <div *ngIf="selectedMarketRentTab === 'new' && !isLoadingMarketRentData">
        <!-- XSLX Download Button -->
        <div
          *ngIf="
            propertiesNewThisQuarter && propertiesNewThisQuarter.length > 0
          "
          style="margin-bottom: 15px; text-align: right;"
        >
          <button
            type="button"
            class="btn btn-success"
            (click)="downloadNewToStatsCsv()"
            [disabled]="showSpinner"
            style="display: flex; align-items: center; gap: 5px;"
          >
            CSV <mat-icon>download</mat-icon>
          </button>
        </div>

        <table
          class="table mobile-table"
          *ngIf="
            propertiesNewThisQuarter && propertiesNewThisQuarter.length > 0
          "
        >
          <thead>
            <tr>
              <th>{{ "tenants-property.market" | translate }}</th>
              <th>{{ "tenants-property.siilaId" | translate }}</th>
              <th>{{ "tenants-property.propertyName" | translate }}</th>
              <th>{{ "tenants-property.constructionStatus" | translate }}</th>
              <th>{{ "tenants-property.deliveryDate" | translate }}</th>
              <th>{{ "tenants-property.tenants" | translate }}</th>
              <th *ngIf="!isMX()">
                {{ "tenants-property.marketRent" | translate }}
              </th>
              <th *ngIf="isMX() && isSelectedCountryMX()">
                {{ "tenants-property.marketRentMX" | translate }}
              </th>
              <th *ngIf="isMX() && !isSelectedCountryMX()">
                {{ "tenants-property.marketRentCO" | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of propertiesNewThisQuarter">
              <td>{{ row.market | langSelector }}</td>
              <td>{{ row.buildingId }}</td>
              <td>
                <a
                  style="color: #3399cc; text-decoration: underline; font-weight: 600; cursor: pointer;"
                  (click)="openTenantsStatsPage(row.buildingId)"
                  >{{ row.buildingName }}</a
                >
              </td>
              <td>{{ row.status | langSelector }}</td>
              <td>{{ row.deliveredDate | date: "dd/MM/yyyy" }}</td>
              <td>
                <ng-container *ngIf="row.tenants; else noTable2">
                  <a
                    style="color: #3399cc; text-decoration: underline; font-weight: 600; cursor: pointer;"
                    (click)="openTenantsPage(row.buildingId)"
                    >{{ "tenants-property.view" | translate }}</a
                  >
                </ng-container>
                <ng-template #noTable2>
                  <span
                    (click)="openTenantsPage(row.buildingId)"
                    style="color: #d32f2f; font-weight: 700; cursor: pointer; text-decoration: underline;"
                    >{{ "tenants-property.noTable" | translate }}</span
                  >
                </ng-template>
              </td>
              <td style="text-align: center;">
                <input
                  type="text"
                  [(ngModel)]="row.marketRent"
                  style="width: 60px; text-align: right;"
                  [ngStyle]="{
                    border:
                      !row.marketRent && row.status.includes('Built')
                        ? '1px solid red'
                        : ''
                  }"
                  [disabled]="row.status && !row.status.includes('Built')"
                  (keypress)="
                    ($event.charCode === 46 ||
                      ($event.charCode >= 48 && $event.charCode <= 57))
                  "
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div
          *ngIf="
            propertiesNewThisQuarter && propertiesNewThisQuarter.length === 0
          "
          style="text-align: center; padding: 20px; color: #888; font-weight: 600;"
        >
          {{ "tenants-property.noPropertiesToShow" | translate }}
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer" style="padding: 0; padding-top: 10px; border: 0;">
    <button
      type="button"
      class="btn btn-secondary"
      (click)="cancelSubmission()"
    >
      {{ "tenants-property.close" | translate }}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="saveMarketRentData()"
      *ngIf="selectedMarketRentTab === 'new'"
    >
      {{ "tenants-property.save" | translate }}
    </button>
  </div>
</ng-template>

<ng-template #flagsReportModal>
  <div
    class="modal-header custom-modal-class-tenants"
    style="padding: 0; border-bottom: 0; padding-bottom: 20px;"
  >
    <h4 class="modal-title" style="font-weight: 600;">
      {{ "tenants-property.flagsReportTitle" | translate }}
    </h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="closeFlagsReportModal()"
    ></button>
  </div>
  <div mat-dialog-content>
    <div
      class="country-type-selector"
      style="margin-bottom: 20px;text-align: center;"
      *ngIf="isMX()"
    >
      <div class="btn-group" role="group" style="gap: 2px;">
        <button
          type="button"
          class="btn tap-reports"
          [class.btn-primary]="
            selectedFlagsCountryId === 2001 && !isRetailFlagsTab
          "
          [class.btn-secondary]="
            selectedFlagsCountryId !== 2001 || isRetailFlagsTab
          "
          (click)="onFlagsCountryTabChange(2001, false)"
        >
          {{ "tenants-property.countryMX" | translate }}
        </button>
        <button
          type="button"
          class="btn tap-reports"
          [class.btn-primary]="
            selectedFlagsCountryId === 2001 && isRetailFlagsTab
          "
          [class.btn-secondary]="
            selectedFlagsCountryId !== 2001 || !isRetailFlagsTab
          "
          (click)="onFlagsCountryTabChange(2001, true)"
        >
          {{ "tenants-property.countryMXretail" | translate }}
        </button>
        <button
          type="button"
          class="btn tap-reports"
          [class.btn-primary]="selectedFlagsCountryId === 3001"
          [class.btn-secondary]="selectedFlagsCountryId !== 3001"
          (click)="onFlagsCountryTabChange(3001, false)"
        >
          {{ "tenants-property.countryCO" | translate }}
        </button>
      </div>
      <div *ngIf="flagsLoading" class="text-center" style="padding: 40px;">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2" style="color: #666;">Loading data...</p>
      </div>
    </div>

    <!-- Report List -->
    <div class="flags-report-list" *ngIf="!flagsLoading">
      <div class="flags-report-item">
        <span class="flags-report-label">{{
          "tenants-property.flagsReportAutomatic" | translate
        }}</span>
        <button
          class="btn btn-success btn-sm flags-XSLX-btn"
          (click)="downloadFlagReport('automatic-flags')"
          [disabled]="downloadingReport === 'automatic-flags'"
        >
          XSLX
          <mat-icon>download</mat-icon>
          <div
            *ngIf="downloadingReport === 'automatic-flags'"
            class="spinner-border text-primary"
            role="status"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
        </button>
      </div>
      <div class="flags-report-item">
        <span class="flags-report-label">{{
          "tenants-property.flagsReportFlags" | translate
        }}</span>
        <button
          class="btn btn-success btn-sm flags-XSLX-btn"
          (click)="downloadFlagReport('flags')"
          [disabled]="downloadingReport === 'flags'"
        >
          XSLX
          <mat-icon>download</mat-icon>
          <div
            *ngIf="downloadingReport === 'flags'"
            class="spinner-border text-primary"
            role="status"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
        </button>
      </div>
      <div class="flags-report-item">
        <span class="flags-report-label">{{
          "tenants-property.flagsReportNotes" | translate
        }}</span>
        <button
          class="btn btn-success btn-sm flags-XSLX-btn"
          (click)="downloadFlagReport('notes')"
          [disabled]="downloadingReport === 'notes'"
        >
          XSLX
          <mat-icon>download</mat-icon>
          <div
            *ngIf="downloadingReport === 'notes'"
            class="spinner-border text-primary"
            role="status"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
        </button>
      </div>
      <div class="flags-report-item">
        <span class="flags-report-label">{{
          "tenants-property.flagsReportComments" | translate
        }}</span>
        <button
          class="btn btn-success btn-sm flags-XSLX-btn"
          (click)="downloadFlagReport('comments')"
          [disabled]="downloadingReport === 'comments'"
        >
          XSLX
          <mat-icon>download</mat-icon>
          <div
            *ngIf="downloadingReport === 'comments'"
            class="spinner-border text-primary"
            role="status"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
        </button>
      </div>
      <div class="flags-report-item">
        <span class="flags-report-label">{{
          "tenants-property.flagsReportAskingRent" | translate
        }}</span>
        <button
          class="btn btn-success btn-sm flags-XSLX-btn"
          (click)="downloadFlagReport('asking-rent')"
          [disabled]="downloadingReport === 'asking-rent'"
        >
          XSLX
          <mat-icon>download</mat-icon>
          <div
            *ngIf="downloadingReport === 'asking-rent'"
            class="spinner-border text-primary"
            role="status"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
        </button>
      </div>
      <div class="flags-report-item">
        <span class="flags-report-label">{{
          "tenants-property.flagsReportVacantVago" | translate
        }}</span>
        <button
          class="btn btn-success btn-sm flags-XSLX-btn"
          (click)="downloadFlagReport('bad-tenant-name')"
          [disabled]="downloadingReport === 'bad-tenant-name'"
        >
          XSLX
          <mat-icon>download</mat-icon>
          <div
            *ngIf="downloadingReport === 'bad-tenant-name'"
            class="spinner-border text-primary"
            role="status"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
        </button>
      </div>
      <div class="flags-report-item">
        <span class="flags-report-label">{{
          "tenants-property.flagsReportArea0" | translate
        }}</span>
        <button
          class="btn btn-success btn-sm flags-XSLX-btn"
          (click)="downloadFlagReport('area-zero')"
          [disabled]="downloadingReport === 'area-zero'"
        >
          XSLX
          <mat-icon>download</mat-icon>
          <div
            *ngIf="downloadingReport === 'area-zero'"
            class="spinner-border text-primary"
            role="status"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
        </button>
      </div>
      <div class="flags-report-item">
        <span class="flags-report-label">{{
          "tenants-property.flagsReportDuplicatedSuites" | translate
        }}</span>
        <button
          class="btn btn-success btn-sm flags-XSLX-btn"
          (click)="downloadFlagReport('duplicated-suites')"
          [disabled]="downloadingReport === 'duplicated-suites'"
        >
          XSLX
          <mat-icon>download</mat-icon>
          <div
            *ngIf="downloadingReport === 'duplicated-suites'"
            class="spinner-border text-primary"
            role="status"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
        </button>
      </div>
      <div class="flags-report-item">
        <span class="flags-report-label">{{
          "tenants-property.flagsReportGreyCheckboxes" | translate
        }}</span>
        <button
          class="btn btn-success btn-sm flags-XSLX-btn"
          (click)="downloadFlagReport('grey-checkboxes')"
          [disabled]="downloadingReport === 'grey-checkboxes'"
        >
          XSLX
          <mat-icon>download</mat-icon>
          <div
            *ngIf="downloadingReport === 'grey-checkboxes'"
            class="spinner-border text-primary"
            role="status"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
        </button>
      </div>
      <div class="flags-report-item">
        <span class="flags-report-label">{{
          "tenants-property.flagsReportNewCorporations" | translate
        }}</span>
        <button
          class="btn btn-success btn-sm flags-XSLX-btn"
          (click)="downloadFlagReport('new-corporations')"
          [disabled]="downloadingReport === 'new-corporations'"
        >
          XSLX
          <mat-icon>download</mat-icon>
          <div
            *ngIf="downloadingReport === 'new-corporations'"
            class="spinner-border text-primary"
            role="status"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
        </button>
      </div>
      <div class="flags-report-item">
        <span class="flags-report-label">{{
          "tenants-property.flagsReportAbsorptions" | translate
        }}</span>
        <button
          class="btn btn-success btn-sm flags-XSLX-btn"
          (click)="downloadFlagReport('absorptions')"
          [disabled]="downloadingReport === 'absorptions'"
        >
          XSLX
          <mat-icon>download</mat-icon>
          <div
            *ngIf="downloadingReport === 'absorptions'"
            class="spinner-border text-primary"
            role="status"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
        </button>
      </div>
    </div>
  </div>
  <div class="modal-footer" style="padding: 0; padding-top: 10px; border: 0;">
    <button
      type="button"
      class="btn btn-secondary"
      (click)="closeFlagsReportModal()"
    >
      {{ "tenants-property.close" | translate }}
    </button>
  </div>
</ng-template>
